import {
    GET_POST_NEW, 
    GET_MASTER_INVENTORY
} from "./type";

const initalState = {
    postSalesData: [],
    inventoryMasterData: []
};
  
const contractNewReducer = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_POST_NEW:
        return {
            ...state,
            postSalesData: payload,
        };
        case GET_MASTER_INVENTORY:
        return {
            ...state,
            inventoryMasterData: payload,
        };
        default:
        return {
            ...state,
        };
    }
};

export default contractNewReducer;
  